/* eslint-disable max-len */
export const MiroIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 48 48" fill="currentColor">
            <g transform="translate(2.4 2.4) scale(1.8)">
                <path fill="currentColor" d="M17.392 0H13.9L17 4.808 10.444 0H6.949l3.102 6.3L3.494 0H0l3.05 8.131L0 24h3.494L10.05 6.985 6.949 24h3.494L17 5.494 13.899 24h3.493L24 3.672 17.392 0z" />
            </g>
        </svg>
    );
};
